import {Inject, Injectable} from '@angular/core';
import {ComponentCatalogOptions, MarkdownFiles, OPTIONS} from '../options.token';
import {MarkedService} from './marked.service';

declare const require: any;

export interface MarkdownGroup {
  name: string;
  markdowns: MarkdownFile[];
  id: string;
}

export interface MarkdownFile {
  group: string;
  name: string;
  key: string;
  id: string;
}

@Injectable({
  providedIn: 'root',
})
export class MarkdownLoaderService {
  private readonly markdowns: { [key: string]: MarkdownFile } = {};
  private readonly groups: { [key: string]: MarkdownGroup } = {};

  readonly files: MarkdownFiles;

  constructor(@Inject(OPTIONS) { markdownFiles }: ComponentCatalogOptions, markedService: MarkedService) {
    this.files = markdownFiles || require.context(`raw-loader!docs/`, true, /.md$/);
    this.files.keys().forEach(key => {
      let [group, name] = key.substring(2).split('/', 2); // tslint:disable-line:prefer-const
      name = name.slice(0, name.length - 3);

      const groupId = markedService.slug(group);
      const fileId = markedService.slug(name);
      const markdown = this.markdowns[`${groupId}/${fileId}`] = { key, group, id: fileId, name };

      const markdowns = this.groups[groupId] = this.groups[groupId] || { name: group, markdowns: [], id: groupId };
      markdowns.markdowns.push(markdown);
    });
  }

  getGroups(): Map<string, MarkdownGroup> {
    const groups = new Map<string, MarkdownGroup>();
    Object.keys(this.groups).forEach(key => {
      const group = this.groups[key];
      groups.set(key, { ...group, markdowns: [...group.markdowns] });
    });
    return groups;
  }

  getMarkdown(groupId: string, fileId: string): MarkdownFile | undefined {
    return this.markdowns[`${groupId}/${fileId}`];
  }
}
